import { render, staticRenderFns } from "./CollectionRecords.vue?vue&type=template&id=0aa095f8&scoped=true"
import script from "./CollectionRecords.vue?vue&type=script&lang=js"
export * from "./CollectionRecords.vue?vue&type=script&lang=js"
import style0 from "./CollectionRecords.vue?vue&type=style&index=0&id=0aa095f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa095f8",
  null
  
)

export default component.exports